<script>
	import Layout from "../../layouts/main";
	import PageHeader from "../../components/page-header";
	import pagination from "laravel-vue-pagination";
	import config from "../../config";
	import {
		get_currency,
		get_decimal,
		date_ranges,
	} from "../../Helper/helper";
	import { commonService, reportService } from "../../services";
	import DateRangePicker from "vue2-daterange-picker";
	import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

	export default {
		components: { Layout, PageHeader, pagination, DateRangePicker },
		data() {
			let startDate = this.moment().startOf("day").toDate();
			let endDate = this.moment().endOf("day").toDate();

			return {
				loading: false,
				sortBy: "created_at",
				freeCashCustomers: [],
				fields: [
					{ key: 'customer_id', label: 'Customer ID', sortable : true },
					{ key: 'customer_name', label: 'Name' },
					{ key: 'customer_email', label: 'Email' },
					{ key: 'customer_phone', label: 'Phone Number' },
					{ key: 'total_free_cash', label: 'Total Free Cash' , sortable : true},
					{ key: 'recharge_amount', label: 'Wallet Balance',  sortable : true },
				],
				paginations: {},
				exporting: false,
				date_ranges: date_ranges,
				dateRange: { startDate, endDate },
				filters: {
					start_date: this.moment().format('YYYY-MM-DD'),
					end_date: this.moment().format('YYYY-MM-DD'),
				},
				config: config,
				limit: 1,
				currency: get_currency(),
			};
		},
		mounted() {
			this.getCustomersWithFreeCash();
		},
		methods: {
			async getCustomersWithFreeCash(page) 
			{
				this.loading = true;
				try 
				{
					reportService.getFreeCashCustomer({ 
						...this.filters,
						sortBy: this.sortBy,
						orderBy: this.sortDesc ? "desc" : "asc",
						page: page 
					}).then(response => {
						var response = response?.data?.result;
						this.paginations = response;
						this.freeCashCustomers = response?.data;
						this.loading = false;
					})
				} catch (error) {
					console.error("Error fetching customers:", error);
					this.loading = false;
				}
			},
			searchByDateRange(date) {
				this.filters = {
					...this.filters,
					start_date: this.moment(date.startDate.toISOString()).format('YYYY-MM-DD'),
					end_date: this.moment(date.endDate.toISOString()).format('YYYY-MM-DD'),
				}

				this.getCustomersWithFreeCash();
			},
			async downloadsCSV() 
			{
				try 
				{
					const token = localStorage.getItem("token"); // Get auth token
					if (!token) {
						console.error("No authentication token found");
						return;
					}

					console.log(token);
					
					const encryptedData = commonService.encryptRequest({
						...this.filters,
						sortBy: this.sortBy,
						orderBy: this.sortDesc ? "desc" : "asc",
						vendor_id: this.$auth.getVendorId(),
					});

					console.log('encryptedData', encryptedData);
					const apiUrl = `${config.api_url}free-cash-customers-export?encd=${encodeURIComponent(encryptedData)}`;

					console.log(apiUrl, config.api_url);
					
					window.open(apiUrl, '_blank');

					
				} catch (error) {
					console.error("Download failed", error);
				}
			},
			sortingChanged(ctx) {
				this.sortBy = ctx.sortBy;
				this.sortDesc = ctx.sortDesc;
				this.getCustomersWithFreeCash();
			},
		},
		filters: {
			date(val) {
				return val ? val.toLocaleString() : "";
			},
		},
	}
</script>

<template>
	<Layout>
		<div>
			<div class="row">
				<div class="col-12">
					<div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
						<div class="page-title-left avatar-main-icon">
							<div class="avatar-xs mr-3">
								<span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
									<i class="bx bx-purchase-tag"></i>
								</span>
							</div>
							<div class="report-tag" v-if="!$auth.partner_login">
								<h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Customers with Free Cash Balance') }}</h4>
								<p><router-link :to="{ name: 'reports-list'}">{{ trans.get('__JSON__.Reports') }}</router-link> > {{ trans.get('__JSON__.Customers with Free Cash Balance') }}</p>
							</div>
							<div class="report-tag" v-else>
								<h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Customers with Free Cash Balance') }}</h4>
								<p><router-link :to="{ name: 'vendor.reports.list'}">{{ trans.get('__JSON__.Reports') }}</router-link> > {{ trans.get('__JSON__.Customers with Free Cash Balance') }}</p>
							</div>
						</div>
						<div class="justify-content-end mb-3 row">
							<div class="">
								<label for="">{{trans.get('__JSON__.Date')}}</label>
								<div class="text-sm-right">
									<div class="mr-2 ">
										<date-range-picker
											ref="picker"
											:locale-data="{
											firstDay: 1,
											format: 'dd-mm-yyyy',
											}"
											:showDropdowns="true"
											:showWeekNumbers="true"
											opens="left"
											v-model="dateRange"
											:ranges="date_ranges()"
											@update="searchByDateRange"
											>

											<template
												v-slot:input="picker"
												style="min-width: 350px"
											>
											{{ moment(picker.startDate.toISOString()).format('YYYY-MM-DD') | date }} -
											{{ moment(picker.endDate.toISOString()).format('YYYY-MM-DD') | date }}
											</template>
										</date-range-picker>
									</div>
								</div>
							</div>
						</div>
					</div>              
				</div>
			</div>
			<div class="row">
				<div class="col-12 list-table-main">
					<div class="card">
						<div class="card-body">

							<!-- Free Cash Table Starts  -->
							<div class="row mt-2">
								<div class="col-12">
									<div class="row mb-2">
									<div class="col-md-6">
									
									</div>
									<div class="col-md-6" v-if="!loading">
										<button @click="downloadsCSV()"
											v-if="$auth.hasSubAdminPermission(config.permissions.reports_export)"
											class="btn btn-primary btn-rounded float-right" :disabled="exporting">
											{{trans.get(!exporting?'__JSON__.Export To CSV':'__JSON__.Exporting')}}
										</button>
									</div>
								</div>
									
								<div class="row table-responsive">
									<div class="col-12 table-main-list table table-centered table-nowrap">
										<b-table 
										:sort-by.sync="sortBy"
										:no-local-sorting="true"
										show-empty
										:items="freeCashCustomers" 
										:fields="fields"
										:busy="loading"
										@sort-changed="sortingChanged"
										>
											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>{{trans.get('__JSON__.Loading...')}}</strong>
												</div>
											</template>

											<template v-slot:cell(total_free_cash)="data">
												<span v-html="currency"></span>
												{{data.item.total_free_cash || 0 }}
											</template>

											<template v-slot:cell(recharge_amount)="data">
												<span v-html="currency"></span>
												{{data.item.recharge_amount || 0 }}
											</template>

											<template #empty="scope">
												<div class="text-center text-muted">
													{{trans.get('__JSON__.No Customer')}}
												</div>
											</template>
				
										</b-table>
									</div>
									<div class="row col-sm-5 offset-sm-7">
										<div class="col">
											<div class="dataTables_paginate paging_simple_numbers float-right">
												<ul class="pagination pagination-rounded mb-0">
													<pagination
													:data="paginations"
													:limit="limit"
													@pagination-change-page="getCustomersWithFreeCash"
													></pagination>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- Free Cash Table End  -->

						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
